module.exports = __webpack_public_path__ + "static/media/1POLICY30.832c65d1.jpg";